import React from "react";
import useAiFeatures, {aiHref} from "./useAiFeatures";

// Agent-only AI entries, drawn like SAM's own navigation: header items match IconLink
// (20px icon, 0.75rem sofia-pro bold label), menu rows match IconLink2 and tiles match the
// dashboard tiles. Every other account type sees nothing here (agent_workspace is false).
const font = "sofia-pro, sans-serif";
const icons = {
  contracts: <path d="M5 1h7l5 5v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Zm6 1.5V7h4.5L11 2.5ZM7 11h7v1.6H7V11Zm0 3.2h7v1.6H7v-1.6Z" />,
  compliance: <path d="M10 1 2.5 4v5.5C2.5 14 5.7 17.9 10 19c4.3-1.1 7.5-5 7.5-9.5V4L10 1Zm-1.2 12.6L5.4 10.2l1.2-1.2 2.2 2.2 4.7-4.7 1.2 1.2-5.9 5.9Z" />,
  insights: <path d="M2 17h16v1.6H2V17Zm1-6h3v5H3v-5Zm5-5h3v10H8V6Zm5 3h3v7h-3V9Z" />,
  search: <path d="M8.5 2a6.5 6.5 0 0 1 5.2 10.4l4.4 4.4-1.3 1.3-4.4-4.4A6.5 6.5 0 1 1 8.5 2Zm0 1.8a4.7 4.7 0 1 0 0 9.4 4.7 4.7 0 0 0 0-9.4Z" />,
};
const Icon = ({route, size = 20}) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">{icons[route]}</svg>
);
const New = () => (
  <small style={{position: "absolute", top: -8, right: -16, background: "#a28c62", color: "#05070b", fontSize: 8, fontWeight: 700, borderRadius: 2, padding: "1px 3px", lineHeight: 1.2, fontFamily: font}}>NEW</small>
);
const tileColours = {contracts: "#13264a", compliance: "#7a1730", insights: "#4a3b8f", search: "#2f3a4a"};

export default function AiEntries({variant = "menu"}) {
  const access = useAiFeatures();
  if (access.status !== "ready" || !access.enabled || !access.agent_workspace) return null;
  const items = variant === "header"
    ? [["contracts", "Contracts"], ["compliance", "Compliance"]]
    : [["contracts", "Contracts"], ["compliance", "Compliance"], ["insights", "Insights"], ["search", "Search all"]];
  const links = items.filter(([route]) => aiHref(route));
  if (variant === "header") {
    return <>{links.map(([route, label]) => (
      <div key={route} style={{textAlign: "center"}}>
        <a href={aiHref(route)} style={{textDecoration: "none", color: "white", position: "relative", display: "inline-block"}}>
          <Icon route={route} />
          <New />
          <p style={{fontSize: "0.75rem", fontFamily: font, fontWeight: 700, color: "white"}} className="ai-entry-label">{label}</p>
        </a>
      </div>
    ))}</>;
  }
  if (variant === "tiles") {
    return <nav aria-label="AI workspaces" style={{display: "flex", flexWrap: "wrap", gap: 16, margin: "24px 0"}}>{links.map(([route, label]) => (
      <a key={route} href={aiHref(route)} style={{flex: "1 1 190px", maxWidth: 220, minHeight: 105, borderRadius: 10, background: tileColours[route], color: "white", textDecoration: "none", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10, fontFamily: font, fontWeight: 700, fontSize: 15, boxShadow: "0 4px 12px rgba(0,0,0,0.18)", position: "relative"}}>
        <Icon route={route} size={30} />
        <span>{label}</span>
        <small style={{position: "absolute", top: 8, right: 8, background: "#a28c62", color: "#05070b", fontSize: 9, fontWeight: 700, borderRadius: 2, padding: "1px 4px"}}>NEW</small>
      </a>
    ))}</nav>;
  }
  return <div>{links.map(([route, label]) => (
    <div key={route} style={{borderTop: "1px solid rgba(151, 151, 151, 0.3)", margin: "0px 20px"}}>
      <a href={aiHref(route)} style={{display: "flex", alignItems: "center", gap: 10, color: "black", textDecoration: "none", textAlign: "center", padding: "14px 0px"}}>
        <span style={{width: 25, display: "flex", justifyContent: "center", color: "#A28C62"}}><Icon route={route} size={22} /></span>
        <p style={{fontFamily: font, color: "#05070b"}}>{label}</p>
        <small style={{background: "#a28c62", color: "#05070b", fontSize: 9, fontWeight: 700, borderRadius: 2, padding: "1px 4px", fontFamily: font}}>NEW</small>
      </a>
    </div>
  ))}</div>;
}
